import React from 'react';
import { Fab } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 1000,
    color: '#fff',
    backgroundColor: orange[400],
    transition: 'all 0.3s ease-in-out',
    borderRadius: '24px',
    height: '48px',
    minWidth: '48px',
    boxShadow: '0 3px 5px 2px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      backgroundColor: orange[600],
      minWidth: '200px', // Aumentado para dar más espacio
      '& $addIcon': {
        transform: 'rotate(90deg)',
        opacity: 0,
        width: 0
      },
      '& $text': {
        opacity: 1,
        width: 'auto'
      }
    }
  },
  addIcon: {
    transition: 'all 0.3s ease-in-out',
    opacity: 1,
    width: '24px'
  },
  text: {
    transition: 'all 0.3s ease-in-out',
    opacity: 0,
    width: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: '0.5px',
    padding: '0 16px' // Añadido padding al texto
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    padding: '0 24px' // Aumentado el padding del wrapper
  }
}));

function FloatingUploadButton({ onClick }) {
  const classes = useStyles();

  return (
    <Fab 
      aria-label="agregar corrección"
      className={classes.fab}
      onClick={onClick}
    >
      <div className={classes.wrapper}>
        <AddIcon className={classes.addIcon} />
        <span className={classes.text}>Agregar corrección</span>
      </div>
    </Fab>
  );
}

export default FloatingUploadButton;